// extracted by mini-css-extract-plugin
export default {"container":"Count_container__LPm6q","number":"Count_number__5NBvu","note":"Count_note__rdjPl","btn":"Count_btn__90roi","externalLinkIcon":"Count_externalLinkIcon__KWzas"};